import { Box, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';

import { SettingsAddressForm } from '@uplift/ui-v2';
import { useStatesQuery } from '@uplift/queries';

export const BillingAddressForm: React.VFC = () => {
  const l10n = useL10n();
  const { data: states } = useStatesQuery();

  return (
    <Box display="flex" flexDirection="column" px={{ xs: 2, sm: 3 }} bgcolor="#fff">
      <Box py={3}>
        <Typography variant="body1">{l10n.accountSettings.billing.billingAddress}</Typography>
      </Box>
      <Box pb={3}>
        {states && <SettingsAddressForm states={states} />}
      </Box>
    </Box>
  );
};
